"use client"
import { useState } from "react"
import Header from "./Header"
import { useNavigate } from "react-router-dom"

const CMI_OPTIONS = [
  {
    label: "Download CMI – Daytime/Pineapple Express",
    fileName: "CMIMediwhistle(Pineapple Express).pdf",
  },
  {
    label: "Download CMI – Nighttime/Tiger's Blood",
    fileName: "CMIMediwhistle(Tiger's Blood).pdf",
  },
  {
    label: "Download CMI – Balanced/Apple Fritter",
    fileName: "CMIMediwhistle(Apple Fritter).pdf",
  },
]

const ProductInfoSection = ({ onCMIClick, onTipsClick }) => {
  const navigate = useNavigate()
  const [showCMIOptions, setShowCMIOptions] = useState(false)

  const handleCMIDownload = async (fileName) => {
    const documentUrl = `/documents/${encodeURIComponent(fileName)}`

    try {
      const response = await fetch(documentUrl)
      if (!response.ok) {
        throw new Error(`Download failed (${response.status})`)
      }

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = objectUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectUrl)
    } catch (error) {
      console.error("CMI download failed:", error)
      const link = document.createElement("a")
      link.href = documentUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const handleTipsClick = () => {
    onTipsClick()
  }

  return (
    <>
      <Header onHomeClick={() => navigate("/")} onHealthcareClick={() => navigate("/contact")} />
      <section className="pt-36 pb-24 bg-stone-50 min-h-screen flex justify-center items-start md:items-center">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-emerald-800 mb-4">
              Product Information
            </h2>
            <p className="text-lg text-charcoal-600 max-w-2xl mx-auto">
              Access essential information and helpful resources for your Mediwhistle device
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* CMI Button */}
            <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300">
              <div className="text-center">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    className="w-10 h-10 text-emerald-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                  Consumer Medicine Information
                </h3>
                <p className="text-charcoal-600 mb-8">
                  Access detailed product information, usage guidelines, and safety instructions
                </p>
                <button
                  type="button"
                  onClick={() => setShowCMIOptions((open) => !open)}
                  className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
                  aria-expanded={showCMIOptions}
                >
                  Download CMI
                </button>

                {showCMIOptions && (
                  <div className="mt-4 flex flex-col gap-3">
                    {CMI_OPTIONS.map((option) => (
                      <button
                        key={option.fileName}
                        type="button"
                        onClick={() => handleCMIDownload(option.fileName)}
                        className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200 text-sm sm:text-base leading-snug"
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Tips & Tricks Button */}
            <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300">
              <div className="text-center">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    className="w-10 h-10 text-amber-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                  Tips & Tricks
                </h3>
                <p className="text-charcoal-600 mb-8">
                  Learn simple instructions and best practices for using your device effectively
                </p>
                <button
                  onClick={handleTipsClick}
                  className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
                >
                  View Tips & Tricks
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProductInfoSection
